import {doDelete, doGet, doPost, doPut} from "./http.service";
import {GeoCity, GeoCountry, GeoDistrict} from "../types/Geo";

export function loadGeoCountries() {
    return doGet<GeoCountry[]>("/public/geo/countries");
}

export function loadGeoCountry(id: string) {
    return doGet<GeoCountry>("/public/geo/countries/" + id);
}

export function loadGeoCity(id: string) {
    return doGet<GeoCity>("/public/geo/cities/" + id);
}

export function loadManageCountries() {
    return doGet<GeoCountry[]>("/geo/countries");
}

export function loadManageCities() {
    return doGet<GeoCity[]>("/geo/cities");
}

export function loadManageCity(id: string) {
    return doGet<GeoCity>("/geo/cities/" + id);
}

export function createCity(countryId: string, name: string) {
    return doPost<GeoCity>("/geo/cities", {countryId, name});
}

export function updateCity(id: string, body: {name?: string; lat?: number; lng?: number; radiusKm?: number}) {
    return doPut<GeoCity>("/geo/cities/" + id, body);
}

export function deleteCity(id: string) {
    return doDelete<void>("/geo/cities/" + id);
}

export function discoverDistricts(cityId: string) {
    return doPost<GeoCity>("/geo/cities/" + cityId + "/discover-districts");
}

export function createDistrict(cityId: string, body: Partial<GeoDistrict> & {name: string}) {
    return doPost<GeoDistrict>("/geo/cities/" + cityId + "/districts", body);
}

export function updateDistrict(id: string, body: Partial<GeoDistrict> & {name: string}) {
    return doPut<GeoDistrict>("/geo/districts/" + id, body);
}

export function deleteDistrict(id: string) {
    return doDelete<void>("/geo/districts/" + id);
}
